function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Tienda
export default [
  {
    path: 'shop',
    name: 'Shop',
    component: loadView('Shop/Home')
  },
  {
    path: 'categories/:slug',
    name: 'ShopCategory',
    component: loadView('Shop/Category')
  },
  {
    path: 'subcategories/:slug',
    name: 'ShopSubCategory',
    component: loadView('Shop/SubCategory')
  },
  {
    path: 'products/:slug',
    name: 'ShopProduct',
    component: loadView('Shop/Product')
  },
  {
    path: 'purchased-products/:type',
    name: 'ShopPurchasedProducts',
    component: loadView('Shop/PurchasedProducts')
  },
  {
    path: 'coins',
    name: 'Coins',
    component: loadView('Shop/Coins')
  },
  {
    path: 'coins/:quantity/buy',
    name: 'CoinsBuy',
    component: loadView('Shop/CoinsBuy')
  },
  {
    path: 'vs',
    name: 'Vs',
    component: loadView('Shop/BetList')
  },
  {
    path: 'premium',
    name: 'Premium',
    component: loadView('Shop/Premium')
  },
  {
    path: 'premium/:month/buy',
    name: 'PremiumBuy',
    component: loadView('Shop/PremiumBuy')
  },
  {
    path: 'vs/:matchId/:position/entry',
    name: 'VsEntry',
    component: loadView('Shop/BetEntry')
  },
  {
    path: 'vs/:matchId/details',
    name: 'VsDetail',
    component: loadView('Shop/VsDetail')
  },
  {
    path: 'vs/:matchId/edit',
    name: 'VsEdit',
    component: loadView('Shop/VsEdit')
  }
]
